<template>
  <div class="container mt-4">
    <h2>Editar Lección</h2>
    <form @submit.prevent="update">
      <div class="form-group mb-3">
        <label class="form-label">Título*</label>
        <input type="text" class="form-control" v-model="updateLesson.title" />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Subtítulo</label>
        <input type="text" class="form-control" v-model="updateLesson.subtitle" />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Descripción</label>
        <QuillEditor
          theme="snow"
          v-model:content="updateLesson.description"
          contentType="html"
        />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Archivo</label>
        <input type="file" class="form-control" @change="uploadFile" />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Enlace de video</label>
        <input type="text" class="form-control" v-model="updateLesson.videoURL" />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Prioridad</label>
        <input type="number" class="form-control" v-model="updateLesson.priority" />
      </div>

      <div class="form-group mb-3">
        <label class="form-check">
          <input type="checkbox" class="form-check-input" v-model="updateLesson.enabled" />
          <span class="form-check-label">Activado</span>
        </label>
      </div>

      <div class="form-group d-flex justify-content-between">
        <router-link :to="backToCourse" class="btn btn-secondary">Volver</router-link>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </div>
</template>

<script>
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import LessonService from "@/services/lesson.service.js";
import Swal from "sweetalert2";

export default {
  name: "EditLessonView",
  components: {
    QuillEditor,
  },
  data() {
    return {
      updateLesson: {
        title: "",
        subtitle: "",
        description: "",
        videoURL: "",
        priority: 0,
        enabled: false,
      },
      file: "",
      courseId: null,
    };
  },
  computed: {
    backToCourse() {
      return this.courseId ? `/app/courses/${this.courseId}` : '/app/courses';
    },
  },
  mounted() {
    this.getLesson();
  },
  methods: {
    async getLesson() {
      const lessonId = this.$route.params.lessonUUID;
      try {
        const response = await LessonService.getLesson(lessonId);
        this.updateLesson = {
          title: response.data.title,
          subtitle: response.data.subtitle,
          description: response.data.description,
          videoURL: response.data.videoURL,
          priority: response.data.priority,
          enabled: response.data.enabled,
        };
        this.courseId = response.data.course;
      } catch (error) {
        console.error("Error fetching lesson:", error);
        Swal.fire("Error", "No se pudo cargar la lección", "error");
      }
    },
    async update() {
      const lessonId = this.$route.params.lessonUUID;

      // Validation: Title required
      if (!this.updateLesson.title.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "El campo título es obligatorio.",
        });
        return;
      }

      // Validation: videoURL must be empty or contain no spaces
      if (this.updateLesson.videoURL.trim() !== "" && /\s/.test(this.updateLesson.videoURL)) {
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "El enlace de video no puede contener espacios.",
        });
        return;
      }

      try {
        // 1. First upload file if exists
        if (this.file) {
          const formData = new FormData();
          formData.append("file", this.file);
          await LessonService.uploadFile(lessonId, formData);
        }

        // 2. Then update lesson data
        const response = await LessonService.updateLesson(lessonId, {
          title: this.updateLesson.title,
          subtitle: this.updateLesson.subtitle,
          description: this.updateLesson.description,
          videoURL: this.updateLesson.videoURL,
          priority: Number(this.updateLesson.priority),
          enabled: this.updateLesson.enabled
        });

        // 3. Show success message
        await Swal.fire({
          icon: "success",
          title: "Actualizado",
          text: "La lección fue actualizada correctamente",
          timer: 1500,
          showConfirmButton: false
        });

        // 4. Redirect back to course
        this.$router.push(this.backToCourse);

      } catch (error) {
        console.error("Update error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "No se pudo actualizar la lección",
        });
      }
    },
    uploadFile(event) {
      this.file = event.target.files[0]; // Just store the file, we'll handle upload in update()
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 800px;
}
</style>
